///---------------------------------------------------------------------------
//! Copyright (C) ASQUARED SRL - All Rights Reserved
//* Unauthorized copying of this file, via any medium is strictly prohibited
//* Proprietary and confidential
//* Written by Alexandru Gârbacea <g99.alex@yahoo.com>, September 2022
//? @author g99.alex@yahoo.com
///---------------------------------------------------------------------------

import React,{ useState, useEffect, useRef } from 'react'
import Popup from '../../Popup';
import AdminDashboard from './AdminDashboard';
import { useAuth } from '../../../context/AuthContext';
import { formatNr } from '../../../services/FormatService';
import { InvoiceToPrint } from '../../../services/PdfService';
import { createNotification } from '../../../services/NotificationService';
import { getDateFromTimestamp, toFormatDate, toFormatTime } from '../../../services/DateService';
import { currentLinesAvailable,
    getAllSubscriptionNames,
    getCifCheck,
    getCompanyLimit,
    getLayoutsLimit,
    getValStatCalc,
    subscriptionLines,
    subscriptionPrices,
    subscriptionTime } from '../../../services/SubscriptionsService';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilter, faEye, faInfo, faDownload, faSpinner, faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons'
import { useReactToPrint } from 'react-to-print';
import './AdminPanel.css'

const AdminPanel = () => {
    const [openPopup, setOpenPopup] = useState(false)
    const [popupData, setPopupData] = useState({})

    const {
        currentUser,
        userData,
        createNewSubscription,
        toggleLayoutState,
        toggleInvoiceState,
        displayInvoices,
        fetchInvoicesByDates,
        loadinvoiceWithSeriesNr,
        loadingAction,
        cancelLastSubscription,
        reconcileCardPayment,
        issueOblioInvoice,
        fetchUnrepliedContacts,
        contactEmails,
        replyToContactMessage,
        loadUsersAPI,
        userAccounts,
        loadActiveSubscriptions,
        activeSubscriptions,
        adminImpersonate,
        // addNewAdmin
    } = useAuth()

    const { data:uData } = userData

    const getPriceWithTax = (val) => {
        return ((21/100) * (+val) + (+val)).toFixed(2)
    }

    //? A <select> hands back strings, and "false" is truthy - written straight into the
    //? subscription it grants exactly the feature the admin just refused, and on "Valid" it
    //? activates a subscription that was meant to stay pending (and bills it as paid).
    const asBool = (value) => value === true || value === 'true'
    //? number inputs also hand back strings; 'custom' is left as it is - subscriptionAllowance
    //? reads it as "no limit", which is the whole point of a Custom PRO subscription
    const asCount = (value) => isNaN(parseInt(value)) ? value : parseInt(value)

    // popup JSX contents
    //? seeded from the price table for the plan selected by default, so a subscription
    //? submitted without touching the type dropdown still matches what that plan sells
    const [subAddState, setSubAddState] = useState({
        id: '',
        type: 0,
        duration: subscriptionTime(0),
        cifCheck: getCifCheck(0),
        compAvailable: getCompanyLimit(0),
        layoutsAvailable: getLayoutsLimit(0),
        valStatCalc: getValStatCalc(0),
        valid: false,
        price: subscriptionPrices(0),
        lines: subscriptionLines(0),
        sendInvoice: true,
        sendEmail: true,
        paid: false
    })

    const handleNewSubSubmit = async (e) => {
        createNotification('info', 'Acțiunea se încarcă, așteptați.')
        e.preventDefault();
        const today = new Date();
        const withInvoice = true;
        const sendEmail = subAddState.sendEmail;
        const isPaid = subAddState.paid;
        const subData = {
            uid: subAddState.id,
            name: subAddState.type,
            date: today.toString(),
            timeStamp: today,
            duration: parseInt(subAddState.duration),
            lines: new Array(parseInt(subAddState.duration)).fill(asCount(subAddState.lines)),
            linesStart: asCount(subAddState.lines),
            cifCheck: asBool(subAddState.cifCheck),
            compAvailable: asCount(subAddState.compAvailable),
            valStatCalc: asBool(subAddState.valStatCalc),
            layoutsAvailable: asCount(subAddState.layoutsAvailable),
            manualDisable: false,
            valid: asBool(subAddState.valid),
            price: subAddState.price
        }
        await createNewSubscription(subData, subAddState.id, withInvoice, sendEmail, isPaid)
        setOpenPopup(false)
    }
    const subAdd = (
        <div className='login-wrapper popup'>
            <form className='login-form popup' onSubmit={(e) => handleNewSubSubmit(e)}>
                <p>ID utilizator</p>
                <input 
                value={subAddState.id} 
                onChange={(e) => setSubAddState(prev => ({...prev, id: e.target.value}))}
                className='input-text' type='text' id='id' required/>

                <p>Tip</p>
                <select 
                value={subAddState.type} 
                onChange={(e) => setSubAddState(prev => ({...prev,
                    type: +e.target.value,
                    duration: subscriptionTime(+e.target.value),
                    cifCheck: getCifCheck(+e.target.value),
                    compAvailable: getCompanyLimit(+e.target.value),
                    layoutsAvailable: getLayoutsLimit(+e.target.value),
                    valStatCalc: getValStatCalc(+e.target.value),
                    valid: false,
                    price: subscriptionPrices(+e.target.value),
                    lines: subscriptionLines(+e.target.value)
                }))}
                className='input-text' id='type' 
                required>
                    {getAllSubscriptionNames().map((name, i) => {
                        return(
                        <option key={`${i} - ${name}`} value={i}>{name}</option>
                        )
                    })}
                </select>

                <p>Durată luni</p>
                {
                subAddState.type >= getAllSubscriptionNames().length - 1 ?
                <input 
                value={subAddState.duration}
                onChange={(e) => setSubAddState(prev => ({...prev, duration: e.target.value}))}
                className='input-text' type='number' id='duration' min="1" required/>
                :
                <div>{subscriptionTime(subAddState.type)}</div>
                }

                <p>Validare VAT</p>
                {
                subAddState.type >= getAllSubscriptionNames().length - 1 ?
                <select 
                value={subAddState.cifCheck} 
                onChange={(e) => setSubAddState(prev => ({...prev, cifCheck: e.target.value}))}
                className='input-text' id='cifCheck' 
                required>
                    <option value={true}>DA</option>
                    <option value={false}>NU</option>
                </select>
                :
                <div>{getCifCheck(subAddState.type) ? 'DA' : 'NU'}</div>
                }

                <p>Firme</p>
                {
                subAddState.type >= getAllSubscriptionNames().length - 1 ?
                <input 
                value={subAddState.compAvailable}
                onChange={(e) => setSubAddState(prev => ({...prev, compAvailable: e.target.value}))}
                className='input-text' type='number' id='compAvailable' min="1" required/>
                :
                <div>{getCompanyLimit(subAddState.type)}</div>
                }

                <p>Machete</p>
                {
                subAddState.type >= getAllSubscriptionNames().length - 1 ?
                <input 
                value={subAddState.layoutsAvailable}
                onChange={(e) => setSubAddState(prev => ({...prev, layoutsAvailable: e.target.value}))}
                className='input-text' type='number' id='layoutsAvailable' min="1" required/>
                :
                <div>{getLayoutsLimit(subAddState.type)}</div>
                }

                <p>Calcul Valoare Statistică</p>
                {
                subAddState.type >= getAllSubscriptionNames().length - 1 ?
                <select 
                value={subAddState.valStatCalc} 
                onChange={(e) => setSubAddState(prev => ({...prev, valStatCalc: e.target.value}))}
                className='input-text' id='valStatCalc' 
                required>
                    <option value={true}>DA</option>
                    <option value={false}>NU</option>
                </select>
                :
                <div>{getValStatCalc(subAddState.type) ? 'DA' : 'NU'}</div>
                }

                <p>Linii /lună</p>
                {
                subAddState.type >= getAllSubscriptionNames().length - 1 ?
                <input 
                value={subAddState.lines}
                onChange={(e) => setSubAddState(prev => ({...prev, lines: e.target.value}))}
                className='input-text' type='number' id='lines' min="1" required/>
                :
                <div>{subscriptionLines(subAddState.type)}</div>
                }

                <p>Valid</p>
                <select 
                value={subAddState.valid} 
                onChange={(e) => setSubAddState(prev => ({...prev, valid: e.target.value}))}
                className='input-text' id='valid' 
                required>
                    <option value={true}>DA</option>
                    <option value={false}>NU</option>
                </select>

                <p>Preț /lună cu TVA (€)</p>
                {
                subAddState.type >= getAllSubscriptionNames().length - 1 ?
                <>
                <input 
                value={subAddState.price}
                onChange={(e) => setSubAddState(prev => ({...prev, price: e.target.value}))}
                className='input-text' type='number' id='price' min="0" step='0.01' required/>
                <div>Total: {getPriceWithTax(parseFloat(subAddState.price)*subAddState.duration)}
                €</div>
                </>
                :
                <>
                <div>{getPriceWithTax(subscriptionPrices(subAddState.type))}€</div>
                <div>Total: { (+getPriceWithTax(subscriptionPrices(subAddState.type)) * subAddState.duration).toFixed(2) } €</div>
                </>
                }
                <div className='checkbox-wrapper' style={{marginTop:'2em'}}>
                    <input className='checkbox' value={subAddState.sendInvoice} defaultChecked={subAddState.sendInvoice}
                    onChange={(e) => setSubAddState(prev => ({...prev, sendInvoice: e.target.checked}))}
                    type="checkbox" id="sendInvoice" name="sendInvoice" title='factura'/>
                    <label htmlFor="sendInvoice">Generează factură
                    </label>
                </div>
                {
                subAddState.sendInvoice &&
                <>
                <div className='checkbox-wrapper' style={{marginTop:'2em'}}>
                    <input className='checkbox' value={subAddState.sendEmail} defaultChecked={subAddState.sendEmail}
                    onChange={(e) => setSubAddState(prev => ({...prev, sendEmail: e.target.checked}))}
                    type="checkbox" id="sendMail" name="sendMail" title='mail'/>
                    <label htmlFor="sendMail">Trimite email utilizatorului
                    </label>
                </div>
                <div className='checkbox-wrapper' style={{marginTop:'2em'}}>
                    <input className='checkbox' value={subAddState.paid} defaultChecked={subAddState.paid}
                    onChange={(e) => setSubAddState(prev => ({...prev, paid: e.target.checked}))}
                    type="checkbox" id="isPaid" name="isPaid" title='platita'/>
                    <label htmlFor="isPaid">Factura este plătită
                    </label>
                </div>
                </>
                }
                <input style={{marginTop:'4em'}} className='input-submit' type="submit" value='Adaugă' />
            </form>
        </div>
    )

    const [subStareState, setSubStareState] = useState({
        id: '',
        type: 1,
        updateInvoice: true,
        sendMail: true
    })

    const handleSubStareAction = async (mode, value) => {
        if (subStareState.id === '') {
            createNotification('error', 'ID invalid')
            return
        }
        createNotification('info', 'Acțiunea se încarcă, așteptați.')
        await toggleLayoutState(subStareState, mode, value)
        setOpenPopup(false)
    }
    const subStare = (
        <div className='ap-popup'>
            <div className='ap-popup-field'>
                <label className='ap-popup-label' htmlFor='subStareType'>Căutare după</label>
                <select
                    value={subStareState.type}
                    onChange={(e) => setSubStareState(prev => ({...prev, type: e.target.value}))}
                    className='input-text' id='subStareType' required>
                    <option value={1}>ID utilizator</option>
                    <option value={0}>ID abonament</option>
                </select>
            </div>

            <div className='ap-popup-field'>
                <label className='ap-popup-label' htmlFor='subStareId'>
                    {parseInt(subStareState.type) === 0 ? 'ID abonament' : 'ID utilizator'}
                </label>
                <input
                    value={subStareState.id}
                    onChange={(e) => setSubStareState(prev => ({...prev, id: e.target.value}))}
                    className='input-text' type='text' id='subStareId' required/>
                {parseInt(subStareState.type) === 1 &&
                    <span className='ap-popup-hint'>Se va selecta ultimul abonament creat al utilizatorului.</span>
                }
            </div>

            <div className='ap-popup-checks'>
                <label className='ap-popup-check-item'>
                    <input className='checkbox' type="checkbox" id="updateInvoice" name="updateInvoice"
                        value={subStareState.updateInvoice} defaultChecked={subStareState.updateInvoice}
                        onChange={(e) => setSubStareState(prev => ({...prev, updateInvoice: e.target.checked}))}/>
                    <span>Setează factura ca <b>plătită</b> (VALIDARE) sau <b>anulată</b> (DEZACTIVARE)</span>
                </label>
                <label className='ap-popup-check-item'>
                    <input className='checkbox' type="checkbox" id="sendMailStare" name="sendMailStare"
                        value={subStareState.sendMail} defaultChecked={subStareState.sendMail}
                        onChange={(e) => setSubStareState(prev => ({...prev, sendMail: e.target.checked}))}/>
                    <span>Trimite email utilizatorului</span>
                </label>
            </div>

            <div className='ap-popup-actions'>
                <div className='ap-popup-action-group'>
                    <div className='button-secondary selected-btn'
                        onClick={() => handleSubStareAction(0, true)}>Validează</div>
                    <div className='button-secondary'
                        onClick={() => handleSubStareAction(0, false)}>Invalidează</div>
                </div>
                {parseInt(uData.accessLevel) > 2 &&
                    <div className='ap-popup-action-group'>
                        <div className='button-secondary selected-btn'
                            onClick={() => handleSubStareAction(1, false)}>Activează</div>
                        <div className='button-secondary'
                            onClick={() => handleSubStareAction(1, true)}>Dezactivează</div>
                    </div>
                }
                <small><i>* <b>Validează</b> = plata a fost efecturată, activează abonamentul!</i></small>
            </div>
        </div>
    )

    // Cancel subscription only if not paid
    const [cancelSubState, setCancelSubState] = useState({
        id: '',
        sendMail: true
    })

    const handleCancelSubAction = async () => {
        if (cancelSubState.id === '') {
            createNotification('error', 'ID invalid')
            return
        }
        createNotification('info', 'Acțiunea se încarcă, așteptați.')
        await cancelLastSubscription(cancelSubState)
        setOpenPopup(false)
    }
    const cancelSub = (
        <div className='login-wrapper popup'>
            <div className='login-form popup'>
                <p>Căutare după ID utilizator</p>
                <input 
                value={cancelSubState.id} 
                onChange={(e) => setCancelSubState(prev => ({...prev, id: e.target.value}))}
                className='input-text' type='text' id='id' required/>

                <div className='checkbox-wrapper' style={{marginBlock:'2em'}}>
                    <input className='checkbox' value={cancelSubState.sendMail} defaultChecked={cancelSubState.sendMail}
                    onChange={(e) => setCancelSubState(prev => ({...prev, sendMail: e.target.checked}))}
                    type="checkbox" id="sendMail" name="sendMail" title='mail'/>
                    <label htmlFor="sendMail">Trimite email utilizatorului
                    </label>
                </div>
                <p>Ultimul abonament poate fi anulat doar dacă nu a fost marcat ca și plătit.</p>
                <p>Dacă există un abonament anterior încă valid, acesta va fi reactivat.</p>
                <div className='admin-action-section'>
                    <div className='button-secondary danger' 
                        onClick={() => handleCancelSubAction()}>ANULEAZĂ</div>
                </div>
            </div>
        </div>
    )

    // State of invoices
    const [subInvStareState, setSubInvStareState] = useState({
        id: '',
        sendMail: true,
        type: 1
    })

    const handleinvStareAction = async (action) => {
        if (subInvStareState.id === '') {
            createNotification('error', 'ID invalid')
            return
        }
        createNotification('info', 'Acțiunea se încarcă, așteptați.')
        await toggleInvoiceState(action, subInvStareState)
        setOpenPopup(false)
    }
    const invStare = (
        <div className='login-wrapper popup'>
            <div className='login-form popup'>
                <p>Căutare după</p>
                <select 
                value={subInvStareState.type} 
                onChange={(e) => setSubInvStareState(prev => ({...prev, type: e.target.value}))}
                className='input-text' id='type' 
                required>
                    <option value={0}>ID factură</option>
                    <option value={1}>Serie și număr</option>
                </select>
                {
                parseInt(subInvStareState.type) === 0 ?
                <>
                    <p>ID factură</p>
                    <input 
                    value={subInvStareState.id} 
                    onChange={(e) => setSubInvStareState(prev => ({...prev, id: e.target.value}))}
                    className='input-text' type='text' id='id' required/>
                </>
                    :
                <>
                    <p>Serie și număr (ex: AB1234)</p>
                    <input 
                    value={subInvStareState.id} 
                    onChange={(e) => setSubInvStareState(prev => ({...prev, id: e.target.value}))}
                    className='input-text' type='text' id='id' required/>
                </>
                }

                <div className='checkbox-wrapper' style={{marginBlock:'2em'}}>
                    <input className='checkbox' value={subInvStareState.sendMail} defaultChecked={subInvStareState.sendMail}
                    onChange={(e) => setSubInvStareState(prev => ({...prev, sendMail: e.target.checked}))}
                    type="checkbox" id="sendMail" name="sendMail" title='mail'/>
                    <label htmlFor="sendMail">Trimite email utilizatorului
                    </label>
                </div>

                <p>Marchează ca</p>
                <div className='admin-action-section'>
                    <div className='button-secondary selected-btn' 
                        onClick={() => handleinvStareAction('1')}>Achitată</div>
                    <div className='button-secondary'
                        onClick={() => handleinvStareAction('2')}>Anulată</div>
                </div>
            </div>
        </div>
    )

    // State of current invoice
    const [currentInvoice, setCurrentInvoice] = useState({})

    // tax function
    const getPriceTotalTva = (val, onlyTva = false) => {
        const TVA = 21/100
        const afterTax = onlyTva ? ((+val) * (+TVA)) : (((+val) * (+TVA)) + (+val))
        return afterTax.toFixed(2)
    }

    // tax function
    const getTotalFromInvoices = (withTva = false, invoicesGiven = filteredInvoices) => {
        const TVA = 21/100
        const total = invoicesGiven.reduce((sum, curr) => (+sum) + (+curr.price), 0)
        const afterTax = withTva ? (((+total) * (+TVA)) + (+total)) : +total
        return afterTax
    }

    // get invoice status string by status value
    const getStatusByType = (type) => {
        switch(type) {
            case '0': // proforma
                return 'PROFORMĂ'
            case '1': // achitata
                return 'ACHITATĂ'
            case '2': // anulata
                return 'ANULATĂ'
            default: // unknown
                return ''
        }
    }

    const invInfo = Object.keys(currentInvoice).length === 0 ? '' : (
        <div className='login-wrapper popup'>
            <div className='login-form popup'>
                <p>ID</p>
                <div>{ currentInvoice.id }</div>

                <p>Serie</p>
                <div>{ currentInvoice.series }</div>

                <p>Număr</p>
                <div>{ currentInvoice.number }</div>

                <p>Dată</p>
                <div>{ toFormatDate(getDateFromTimestamp(currentInvoice.timestamp)) }</div>

                <p>Stare</p>
                <div>{ getStatusByType(currentInvoice.status) }</div>

                <p>Preț</p>
                <div>Cu TVA: { getPriceTotalTva(currentInvoice.price) } Lei • Fără TVA: { currentInvoice.price } Lei • TVA: { getPriceTotalTva(currentInvoice.price, true) } Lei</div>

                <p>Produs</p>
                <div>{ currentInvoice.subscription.name }</div>

                <p>ID Produs</p>
                <div>{ currentInvoice.subscription.id }</div>

                <p>Email Client</p>
                <div>{ currentInvoice.client.email }</div>

                <p>ID Client</p>
                <div>{ currentInvoice.uid }</div>
            </div>
        </div>
    )

    const [currentContactMsg, setCurrentContactMsg] = useState({});

    const contactReply = (
        <div className='login-wrapper popup'>
            <div className='login-form popup'>
                <small>{toFormatDate(getDateFromTimestamp(currentContactMsg.timeStamp))} - {toFormatTime(getDateFromTimestamp(currentContactMsg.timeStamp))}</small>
                <p>Nume</p>
                <span>{currentContactMsg.name}</span>
                
                <p>Email</p>
                <span>{currentContactMsg.fromMail}</span>

                <p>Firma</p>
                <span>{currentContactMsg.company}</span>

                <p>Locație</p>
                <span>{currentContactMsg.location}</span>

                <p>Mesaj</p>
                <span style={{whiteSpace:"pre-line"}}>{currentContactMsg.message}</span>

                <p>Mesajul tău</p>
                <textarea className="input-text" type="text" name="replyMessage" id="replyMessage" rows="5" 
                    value={currentContactMsg.replyMsg} onChange={(e) => setCurrentContactMsg(prev => ({...prev, replyMsg: e.target.value}))} />

                <div className='button-secondary selected-btn'
                    onClick={() => {
                        replyToContactMessage(currentContactMsg);
                        setOpenPopup(false);
                    }}>Răspunde</div>
            </div>
        </div>
    )

    const handleOpenCurrentMessage = (msg) => {
        setCurrentContactMsg(msg);
        handleOpenPopup(5);
    }

    //-----------------------------------------------------------------------------------------
    //* \brief
    //? Re-checks a card payment and finishes an activation that was left hanging: a NETOPIA
    //? notification that never arrived, or one that arrived but could not be applied.
    //? Safe to run more than once - a payment that is already activated is left alone.
    //-----------------------------------------------------------------------------------------
    const [cardPaymentState, setCardPaymentState] = useState({ orderID: '', result: null })

    const handleReconcile = async () => {
        if (cardPaymentState.orderID.trim() === '') {
            createNotification('error', 'Introduceți ID-ul comenzii')
            return
        }
        const result = await reconcileCardPayment(cardPaymentState.orderID.trim())
        setCardPaymentState(prev => ({ ...prev, result }))
    }

    const cardPayment = (
        <div className='ap-popup'>
            <div className='ap-popup-info'>
                <div>
                    Verifică la NETOPIA starea unei plăți cu cardul și, dacă plata a fost efectuată,
                    activează abonamentul și marchează factura ca achitată.
                </div>
                <div style={{marginTop:'0.4em'}}>
                    Se folosește când un client a plătit dar abonamentul nu s-a activat singur.
                </div>
            </div>

            <div className='ap-popup-field'>
                <label className='ap-popup-label' htmlFor='cardOrderId'>ID comandă (orderID)</label>
                <input
                    value={cardPaymentState.orderID}
                    onChange={(e) => setCardPaymentState({ orderID: e.target.value, result: null })}
                    className='input-text' type='text' id='cardOrderId' placeholder='PIabc12345XYZ' required/>
                <span className='ap-popup-hint'>
                    Se găsește în colecția <b>card_payments</b> sau în emailul de alertă primit.
                </span>
            </div>

            {cardPaymentState.result &&
                <div className={`ap-popup-${cardPaymentState.result.ok ? 'info' : 'warning'}`}>
                    <div>{cardPaymentState.result.message || cardPaymentState.result.error}</div>
                    {cardPaymentState.result.record &&
                        <div style={{marginTop:'0.4em'}}>
                            Stare înregistrată: <b>{cardPaymentState.result.record.status}</b>
                            {cardPaymentState.result.record.netopiaStatus !== undefined &&
                                <> | cod NETOPIA: <b>{cardPaymentState.result.record.netopiaStatus}</b></>}
                        </div>
                    }
                </div>
            }

            <div className='ap-popup-actions'>
                <div className='ap-popup-action-group'>
                    <div className='button-secondary selected-btn' onClick={handleReconcile}>
                        {loadingAction
                            ? <FontAwesomeIcon className='spinner' icon={faSpinner}/>
                            : 'Verifică și finalizează'}
                    </div>
                </div>
            </div>
        </div>
    )

    //-----------------------------------------------------------------------------------------
    //* \brief
    //? Issues the fiscal invoice in OBLIO for an invoice that does not have one yet.
    //? Used when OBLIO was unreachable at the moment of payment, so the order went through
    //? without a fiscal number. Safe to run repeatedly - an invoice that already has an
    //? OBLIO number is returned untouched rather than issued twice.
    //-----------------------------------------------------------------------------------------
    const [oblioState, setOblioState] = useState({ id: '', collectType: 'card', result: null })

    const handleIssueOblio = async () => {
        if (oblioState.id.trim() === '') {
            createNotification('error', 'Introduceți ID-ul facturii')
            return
        }
        const result = await issueOblioInvoice(oblioState.id.trim(), oblioState.collectType)
        setOblioState(prev => ({ ...prev, result }))
        if (result.ok) {
            createNotification('success', result.message || `Factura ${result.seriesNumber} a fost emisă.`, 'OBLIO', 20000)
        }
        else if (result.disabled) {
            createNotification('info', 'Facturarea prin OBLIO nu este activată.', 'OBLIO', 15000)
        }
        else {
            createNotification('error', result.error || 'Emiterea a eșuat', 'OBLIO', 20000)
        }
    }

    const oblioInvoice = (
        <div className='ap-popup'>
            <div className='ap-popup-info'>
                <div>
                    Emite factura fiscală în OBLIO pentru o factură care nu are încă număr —
                    de exemplu când OBLIO nu a putut fi contactat în momentul plății.
                </div>
                <div style={{marginTop:'0.4em'}}>
                    Numărul este atribuit de OBLIO, iar contorul local este adus la zi automat.
                </div>
            </div>

            <div className='ap-popup-field'>
                <label className='ap-popup-label' htmlFor='oblioInvId'>ID factură</label>
                <input
                    value={oblioState.id}
                    onChange={(e) => setOblioState(prev => ({ ...prev, id: e.target.value, result: null }))}
                    className='input-text' type='text' id='oblioInvId' required/>
                <span className='ap-popup-hint'>
                    ID-ul documentului din colecția <b>invoices</b> (se vede în "Informații factură").
                </span>
            </div>

            <div className='ap-popup-field'>
                <label className='ap-popup-label' htmlFor='oblioCollect'>Încasat prin</label>
                <select
                    value={oblioState.collectType}
                    onChange={(e) => setOblioState(prev => ({ ...prev, collectType: e.target.value }))}
                    className='input-text' id='oblioCollect'>
                    <option value='card'>Card</option>
                    <option value='transfer'>Ordin de plată</option>
                </select>
            </div>

            {oblioState.result &&
                <div className={`ap-popup-${oblioState.result.ok ? 'info' : 'warning'}`}>
                    <div>{oblioState.result.message || oblioState.result.error ||
                        (oblioState.result.disabled ? 'OBLIO nu este activat.' : '')}</div>
                    {oblioState.result.link &&
                        <div style={{marginTop:'0.4em'}}>
                            <a href={oblioState.result.link} target='_blank' rel='noopener noreferrer'>
                                Deschide factura
                            </a>
                        </div>
                    }
                </div>
            }

            <div className='ap-popup-actions'>
                <div className='ap-popup-action-group'>
                    <div className='button-secondary selected-btn' onClick={handleIssueOblio}>
                        {loadingAction
                            ? <FontAwesomeIcon className='spinner' icon={faSpinner}/>
                            : 'Emite factura'}
                    </div>
                </div>
            </div>
        </div>
    )

    const popupContent = [
        subAdd,
        subStare,
        invStare,
        invInfo,
        cancelSub,
        contactReply,
        cardPayment,
        oblioInvoice
    ]

    const popupTitles = [
        'Adaugă abonament',
        'Stare abonament',
        'Stare factură',
        'Informații factură',
        'Anulează abonament',
        'Răspunde la mesaj',
        'Verifică plata cu cardul',
        'Factură OBLIO'
    ]

    const handleOpenPopup = (content) => {
        const dataToAdd = {
            type: 3,
            content,
            title: popupTitles[content]
        }
        setPopupData(dataToAdd)
        setOpenPopup(true)
    }

    const emptyFilters = {
        series: '',
        number: '',
        id: '',
        status: '',
        type: '',
        uid: '',
        client: {
            email: ''
        },
        subscription: {
            id: '',
            name: ''
        }
    }

    const [getInvoiceDate, setGetInvoiceDate] = useState({
        min: '',
        max: ''
    })
    const [invoiceTextSearch, setInvoiceTextSearch] = useState('')
    const [filteredInvoices, setFilteredInvoices] = useState([])
    const [showFilters, setShowFilters] = useState(false)
    const [filters, setFilters] = useState(emptyFilters)

    // Get all invoices into the filter state when fetched
    useEffect(() => {
      setFilteredInvoices(displayInvoices)
    }, [displayInvoices])
    

    const loadInvoicesFromDates = async () => {
        if (getInvoiceDate.min === '' || getInvoiceDate.max === '') return createNotification('error', 'Selectați date valide')
        const dates = { from: new Date(getInvoiceDate.min), to:  new Date(getInvoiceDate.max)}
        if (dates.from > dates.to) return createNotification('error', 'Data de început nu poate fi mai mare decât cea de final')
        // setFilteredInvoices(displayInvoices)
        await fetchInvoicesByDates(dates)
    }

    const filterArray = (filtersGiven, arr) => {
        // function to get string 
        const getValue = (value) => (typeof value === 'string' ? value.toUpperCase() : value.toString());
        const filterKeys = Object.keys(filtersGiven);
        // function to filter by keys
        const filterByKeys = (res, keys = filterKeys, filterObj = filtersGiven) => {
            return keys.every( key => {
                if(!filterObj[key]) return arr;
                let isEq = getValue(filterObj[key]).toString().includes(getValue(res[key]))
                if (isEq && getValue(filterObj[key]) === '[object Object]') {
                    // recursion to filter by nested object keys
                    isEq = filterByKeys(res[key], Object.keys(filterObj[key]), filterObj[key])
                }
                return isEq
            })
        }
        // filter array
        const filterRes = arr.filter( res => {
            return filterByKeys(res)
        })
        return filterRes;
    }

    const filterAction = (isOn) => {
        // reset filter action
        if (!isOn) {
            setFilters(emptyFilters)
            setFilteredInvoices(displayInvoices)
            return
        }
        // filter action
        setFilteredInvoices(filterArray(filters, displayInvoices))
    }

    const openInvoiceInfo = (index) => {
        if (!filteredInvoices || !filteredInvoices[index]) return
        // set state to show in popup
        setCurrentInvoice(filteredInvoices[index])
        // open popup
        handleOpenPopup(3)
    }

    // print and show invoice
    const [printData, setPrintData] = useState({})
    const [invoiceDownload, setInvoiceDownload] = useState(false)
    const [printStart, setPrintStart] = useState(false)
    const invoiceRef = useRef()

    const startPrint = useReactToPrint({
        content: () => invoiceRef.current,
    });

    const printInvoice = async(inv) => {
        if (printStart) return
        setInvoiceDownload(false)
        createNotification('info', 'Se generează factura')
        setPrintData(inv)
        setPrintStart(true)
        await new Promise(r => setTimeout(r, 500));
        startPrint()
        await new Promise(r => setTimeout(r, 500));
        setPrintStart(false)
    }

    const downloadInvoice = async (inv) => {
        createNotification('info', `Se descarcă documentul ${inv.seriesNumber}.`)
        setInvoiceDownload(true)
        setPrintData(inv)
        setPrintStart(true)
        await new Promise(r => setTimeout(r, 200));
        await new Promise(r => setTimeout(r, 200));
        setPrintStart(false)
        setInvoiceDownload(false)
    }

    const downloadAllInvoices = async () => {
        for (let inv of filteredInvoices) {
            await downloadInvoice(inv)
        }
    }

    // Sort state for active subscriptions table
    const [subSort, setSubSort] = useState({ key: null, dir: 'asc' })
    // Hide subscriptions with no lines consumed this month
    const [hideUnusedSubs, setHideUnusedSubs] = useState(false)

    //? Lines consumed out of the current month's allowance, or null when it cannot be told
    const getSubLinesUsed = (sub) => {
        const available = currentLinesAvailable(sub)
        if (isNaN(available)) return null
        return Math.max(0, sub.linesStart - available)
    }

    const handleSubSort = (key) => {
        setSubSort(prev => ({
            key,
            dir: prev.key === key && prev.dir === 'asc' ? 'desc' : 'asc'
        }))
    }

    const getSubSortIcon = (key) => {
        if (subSort.key !== key) return faSort
        return subSort.dir === 'asc' ? faSortUp : faSortDown
    }

    const getSubSortValue = (sub, key) => {
        switch (key) {
            case 'name': return getAllSubscriptionNames()[sub.name] || sub.name
            case 'price': return +sub.price || 0
            case 'duration': return +sub.duration || 0
            case 'linesStart': return +sub.linesStart || 0
            case 'timeStamp': return sub.timeStamp?.seconds || 0
            case 'expiry': {
                const start = sub.timeStamp?.seconds
                    ? getDateFromTimestamp(sub.timeStamp)
                    : sub.date ? new Date(sub.date) : null
                if (!start || !sub.duration) return 0
                const exp = new Date(start)
                exp.setMonth(exp.getMonth() + sub.duration)
                return exp.getTime()
            }
            case 'cifCheck': return sub.cifCheck ? 1 : 0
            case 'valStatCalc': return sub.valStatCalc ? 1 : 0
            case 'uid': return sub.uid || ''
            case 'subId': return sub.subId || ''
            default: return ''
        }
    }

    const visibleSubscriptions = hideUnusedSubs
        ? activeSubscriptions.filter(sub => getSubLinesUsed(sub) > 0)
        : activeSubscriptions

    const sortedSubscriptions = [...visibleSubscriptions].sort((a, b) => {
        if (!subSort.key) return 0
        const valA = getSubSortValue(a, subSort.key)
        const valB = getSubSortValue(b, subSort.key)
        const cmp = typeof valA === 'string' ? valA.localeCompare(valB) : valA - valB
        return subSort.dir === 'asc' ? cmp : -cmp
    })

    //? opens the "Stare abonament" popup already pointed at a subscription from the dashboard
    const openSubStareFor = (subId) => {
        setSubStareState(prev => ({ ...prev, id: subId, type: 0 }))
        handleOpenPopup(1)
    }

    const simulateUserPrompt = () => {
        const userInput = window.prompt('ID of user to simulate:');
        if (userInput !== null && userInput !== "") {
            adminImpersonate(userInput);
        }
        else createNotification("error", "Valoare invalidă")
    }

    if(!uData.admin) return (
        <></>
    )

    return (
        <div className='app-default-wrapper'>

            {/* ── Header ──────────────────────────────────────────────── */}
            <div className='ap-header'>
                <h2 className='ap-title'>Panou administrator</h2>
                <span className='ap-access-badge'>Access {uData.accessLevel}</span>
            </div>

            {/* ── User info ────────────────────────────────────────────── */}
            <div className='ap-card'>
                <span className='ap-card-label'>Date utilizator</span>
                <div className='ap-info-grid'>
                    <div className='ap-info-item'>
                        <span className='ap-info-key'>ID</span>
                        <span className='ap-info-val'>{currentUser.uid}</span>
                    </div>
                    <div className='ap-info-item'>
                        <span className='ap-info-key'>Nume</span>
                        <span className='ap-info-val'>{currentUser.displayName}</span>
                    </div>
                    <div className='ap-info-item'>
                        <span className='ap-info-key'>Email</span>
                        <span className='ap-info-val'>{currentUser.email}</span>
                    </div>
                    <div className='ap-info-item'>
                        <span className='ap-info-key'>Nivel acces</span>
                        <span className='ap-info-val'>{uData.accessLevel}</span>
                    </div>
                </div>
            </div>

            {/* ── Action cards ─────────────────────────────────────────── */}
            <div className='ap-sections'>

                {/* Subscriptions */}
                <div className='ap-card'>
                    <span className='ap-card-label'>Abonamente</span>
                    <div className='ap-action-row'>
                        <div className='button-secondary' onClick={() => handleOpenPopup(0)}>Adaugă</div>
                        {parseInt(uData.accessLevel) > 1 &&
                            <div className='button-secondary' onClick={() => handleOpenPopup(1)}>Stare</div>
                        }
                        {parseInt(uData.accessLevel) > 1 &&
                            <div className='button-secondary danger' onClick={() => handleOpenPopup(4)}>Anulează</div>
                        }
                    </div>
                </div>

                {/* Invoices – actions + search */}
                <div className='ap-card'>
                    <span className='ap-card-label'>Facturi</span>
                    {parseInt(uData.accessLevel) > 1 &&
                        <div className='ap-action-row'>
                            <div className='button-secondary' onClick={() => handleOpenPopup(2)}>Stare factură</div>
                            <div className='button-secondary' onClick={() => handleOpenPopup(6)}>Plată card</div>
                            <div className='button-secondary' onClick={() => handleOpenPopup(7)}>Factură OBLIO</div>
                        </div>
                    }
                    <div className='ap-search-row'>
                        <label className='ap-search-label'>Serie și număr</label>
                        <div className='ap-search-group'>
                            <input value={invoiceTextSearch} placeholder='ABC1234'
                                onChange={(e) => setInvoiceTextSearch(e.target.value)}
                                className='input-text' type='text' id='seriesNrSearch' />
                            {loadingAction ?
                                <FontAwesomeIcon className='spinner' icon={faSpinner}/> :
                                <div className='button-secondary' onClick={() => loadinvoiceWithSeriesNr(invoiceTextSearch)}>Afișează</div>
                            }
                        </div>
                    </div>
                    <div className='ap-search-row'>
                        <label className='ap-search-label'>Interval date</label>
                        <div className='ap-search-group'>
                            <input value={getInvoiceDate.min}
                                onChange={(e) => setGetInvoiceDate(prev => ({...prev, min: e.target.value}))}
                                className='input-text' type='date' id='dateStart' />
                            <span className='ap-search-sep'>—</span>
                            <input value={getInvoiceDate.max}
                                onChange={(e) => setGetInvoiceDate(prev => ({...prev, max: e.target.value}))}
                                className='input-text' type='date' id='dateEnd' />
                            {loadingAction ?
                                <FontAwesomeIcon className='spinner' icon={faSpinner}/> :
                                <div className='button-secondary' onClick={() => loadInvoicesFromDates()}>Afișează</div>
                            }
                        </div>
                    </div>
                </div>

            </div>

            {/* ── Owner dashboard (each section loads when opened) ─────── */}
            {uData.admin && parseInt(uData.accessLevel) > 9 &&
                <AdminDashboard
                    onValidateSub={openSubStareFor}
                    canValidate={parseInt(uData.accessLevel) > 1}/>
            }

            {/* ── Invoice results ──────────────────────────────────────── */}
            {displayInvoices.length > 0 &&
                <div className='ap-card'>
                    <div className='ap-results-header'>
                        <span className='ap-card-label'>Facturi afișate</span>
                        <FontAwesomeIcon className='button-secondary ap-filter-btn' title='Filtre'
                            onClick={() => setShowFilters(!showFilters)} icon={faFilter}/>
                    </div>

                    {showFilters &&
                        <div className='ap-filters'>
                            <div className='ap-filters-grid'>
                                <div className='ap-filter-item'>
                                    <label>Serie</label>
                                    <input value={filters.series}
                                        onChange={(e) => setFilters(prev => ({...prev, series: e.target.value}))}
                                        className='input-text' name='series' id='series' type='text'/>
                                </div>
                                <div className='ap-filter-item'>
                                    <label>Număr</label>
                                    <input value={filters.number}
                                        onChange={(e) => setFilters(prev => ({...prev, number: e.target.value}))}
                                        className='input-text' name='number' id='number' type='number'/>
                                </div>
                                <div className='ap-filter-item'>
                                    <label>ID</label>
                                    <input value={filters.id}
                                        onChange={(e) => setFilters(prev => ({...prev, id: e.target.value}))}
                                        className='input-text' name='id' id='id' type='text'/>
                                </div>
                                <div className='ap-filter-item'>
                                    <label>Stare</label>
                                    <select value={filters.status}
                                        onChange={(e) => setFilters(prev => ({...prev, status: e.target.value}))}
                                        className='input-text' id='status'>
                                        <option value={''}>Toate</option>
                                        <option value={'0'}>Neachitată</option>
                                        <option value={'1'}>Achitată</option>
                                        <option value={'2'}>Anulată</option>
                                    </select>
                                </div>
                                <div className='ap-filter-item'>
                                    <label>Tip</label>
                                    <select value={filters.type}
                                        onChange={(e) => setFilters(prev => ({...prev, type: e.target.value}))}
                                        className='input-text' id='type'>
                                        <option value={''}>Toate</option>
                                        <option value={'0'}>Proformă</option>
                                        <option value={'1'}>Factură</option>
                                    </select>
                                </div>
                                <div className='ap-filter-item'>
                                    <label>Email utilizator</label>
                                    <input value={filters.client.email}
                                        onChange={(e) => setFilters(prev => ({...prev, client: {...prev.client, email: e.target.value}}))}
                                        className='input-text' name='uName' id='uName' type='text'/>
                                </div>
                                <div className='ap-filter-item'>
                                    <label>ID utilizator</label>
                                    <input value={filters.uid}
                                        onChange={(e) => setFilters(prev => ({...prev, uid: e.target.value}))}
                                        className='input-text' name='uId' id='uId' type='text'/>
                                </div>
                                <div className='ap-filter-item'>
                                    <label>Nume pachet</label>
                                    <input value={filters.subscription.name}
                                        onChange={(e) => setFilters(prev => ({...prev, subscription: {...prev.subscription, name: e.target.value}}))}
                                        className='input-text' name='SubName' id='SubName' type='text'/>
                                </div>
                                <div className='ap-filter-item'>
                                    <label>ID pachet</label>
                                    <input value={filters.subscription.id}
                                        onChange={(e) => setFilters(prev => ({...prev, subscription: {...prev.subscription, id: e.target.value}}))}
                                        className='input-text' name='SubId' id='SubId' type='text'/>
                                </div>
                            </div>
                            <div className='ap-filters-actions'>
                                <div className='button-secondary' onClick={() => filterAction(false)}>Resetează</div>
                                <div className='button-secondary selected-btn' onClick={() => filterAction(true)}>Aplică</div>
                            </div>
                        </div>
                    }

                    <div className='ap-table-wrap'>
                        <table className='ap-table'>
                            <thead>
                                <tr>
                                    <th>Serie</th>
                                    <th>Număr</th>
                                    <th>Dată</th>
                                    <th>Stare</th>
                                    <th>Acțiuni</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredInvoices.map((inv, i) => (
                                    <tr key={`${i}-${inv.id}`}>
                                        <td>{inv.series}</td>
                                        <td>{inv.number}</td>
                                        <td>{toFormatDate(getDateFromTimestamp(inv.timestamp))}</td>
                                        <td>
                                            <span className={`ap-status ap-status--${inv.status}`}>
                                                {getStatusByType(inv.status)}
                                            </span>
                                        </td>
                                        <td>
                                            <div className='ap-inv-actions'>
                                                <FontAwesomeIcon title='VEZI'
                                                    onClick={() => printInvoice(inv)}
                                                    className='button-secondary adm-btn no-margin' icon={faEye}/>
                                                <FontAwesomeIcon title='DESCARCĂ'
                                                    onClick={() => downloadInvoice(inv)}
                                                    className='button-secondary selected-btn no-margin' icon={faDownload}/>
                                                <FontAwesomeIcon title='INFO'
                                                    onClick={() => openInvoiceInfo(i)}
                                                    className='button-secondary adm-btn no-margin' icon={faInfo}/>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {filteredInvoices.length > 0 &&
                        <div className='ap-invoice-summary'>
                            <span>Nr facturi: <b>{filteredInvoices.length}</b></span>
                            <span>
                                Total: <b>{formatNr(getTotalFromInvoices(true))} LEI</b> cu TVA
                                {' • '}
                                <b>{formatNr(getTotalFromInvoices(false))} LEI</b> fără TVA
                            </span>
                            <FontAwesomeIcon title='DESCARCĂ TOT'
                                onClick={() => downloadAllInvoices()}
                                className='button-secondary no-margin' icon={faDownload}/>
                        </div>
                    }
                </div>
            }

            {/* ── Contact messages ─────────────────────────────────────── */}
            <div className='ap-card'>
                <div className='ap-results-header'>
                    <span className='ap-card-label'>Mesaje de contact</span>
                    {loadingAction ?
                        <FontAwesomeIcon className='spinner' icon={faSpinner}/> :
                        <div className='button-secondary' onClick={fetchUnrepliedContacts}>Afișează necitite</div>
                    }
                </div>
                {contactEmails.length > 0 &&
                    <div className='ap-table-wrap'>
                        <table className='ap-table'>
                            <thead>
                                <tr>
                                    <th>Dată</th>
                                    <th>Nume</th>
                                    <th>Email</th>
                                </tr>
                            </thead>
                            <tbody>
                                {contactEmails.map((contactMail, i) => (
                                    <tr key={i + contactMail.timeStamp.toString()}
                                        onClick={() => handleOpenCurrentMessage(contactMail)}
                                        className='ap-row-clickable'>
                                        <td>{toFormatDate(getDateFromTimestamp(contactMail.timeStamp))} — {toFormatTime(getDateFromTimestamp(contactMail.timeStamp))}</td>
                                        <td>{contactMail.name}</td>
                                        <td>{contactMail.fromMail}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                }
            </div>

            {/* ── Active subscriptions ──────────────────────────────────── */}
            {uData.admin && parseInt(uData.accessLevel) > 9 &&
                <div className='ap-card'>
                    <div className='ap-results-header'>
                        <span className='ap-card-label'>Abonamente active</span>
                        {loadingAction ?
                            <FontAwesomeIcon className='spinner' icon={faSpinner}/> :
                            <div className='button-secondary' onClick={() => loadActiveSubscriptions()}>Încarcă abonamente</div>
                        }
                    </div>
                    {activeSubscriptions.length > 0 &&
                        <div className='ap-sub-filterbar'>
                            <div className={`button-secondary${hideUnusedSubs ? ' selected-btn' : ''}`}
                                onClick={() => setHideUnusedSubs(!hideUnusedSubs)}>
                                Doar cu linii folosite
                            </div>
                            <span className='ap-sub-filterbar-count'>
                                {sortedSubscriptions.length} / {activeSubscriptions.length} abonamente
                            </span>
                        </div>
                    }
                    {activeSubscriptions.length > 0 &&
                        <div className='ap-table-wrap'>
                            <table className='ap-table'>
                                <thead>
                                    <tr>
                                        {[
                                            ['name', 'Abonament'],
                                            ['price', 'Preț'],
                                            ['duration', 'Durată'],
                                            ['linesStart', 'Linii folosite'],
                                            ['timeStamp', 'Data creare'],
                                            ['expiry', 'Data expirare'],
                                            ['cifCheck', 'CIF Check'],
                                            ['valStatCalc', 'Val. Stat.'],
                                            ['uid', 'uID'],
                                            ['subId', 'Sub ID'],
                                        ].map(([key, label]) => (
                                            <th key={key} className='ap-th-sortable' onClick={() => handleSubSort(key)}>
                                                {label}
                                                <FontAwesomeIcon className='ap-sort-icon' icon={getSubSortIcon(key)}/>
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {sortedSubscriptions.map((sub, i) => (
                                        <tr key={sub.subId + i}>
                                            <td>{getAllSubscriptionNames()[sub.name] || sub.name}</td>
                                            <td>{sub.price} €</td>
                                            <td>{sub.duration} luni</td>
                                            <td>{(() => {
                                                const used = getSubLinesUsed(sub)
                                                if (used === null) return formatNr(sub.linesStart)
                                                return <span className={used > 0 ? '' : 'ap-lines-unused'}>
                                                    {formatNr(used)}/{formatNr(sub.linesStart)}
                                                </span>
                                            })()}</td>
                                            <td>{sub.timeStamp?.seconds
                                                ? toFormatDate(getDateFromTimestamp(sub.timeStamp)) + ' ' + toFormatTime(getDateFromTimestamp(sub.timeStamp))
                                                : sub.date || '—'}</td>
                                            <td>{(() => {
                                                const start = sub.timeStamp?.seconds
                                                    ? getDateFromTimestamp(sub.timeStamp)
                                                    : sub.date ? new Date(sub.date) : null
                                                if (!start || !sub.duration) return '—'
                                                const exp = new Date(start)
                                                exp.setMonth(exp.getMonth() + sub.duration)
                                                return toFormatDate(exp)
                                            })()}</td>
                                            <td>
                                                <span className={`ap-status ap-status--${sub.cifCheck ? '1' : '2'}`}>
                                                    {sub.cifCheck ? 'Da' : 'Nu'}
                                                </span>
                                            </td>
                                            <td>
                                                <span className={`ap-status ap-status--${sub.valStatCalc ? '1' : '2'}`}>
                                                    {sub.valStatCalc ? 'Da' : 'Nu'}
                                                </span>
                                            </td>
                                            <td className='ap-mono'>{sub.uid}</td>
                                            <td className='ap-mono'>{sub.subId}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    }
                </div>
            }

            {/* ── Platform users (high access) ─────────────────────────── */}
            {uData.admin && parseInt(uData.accessLevel) > 9 &&
                <div className='ap-card'>
                    <div className='ap-results-header'>
                        <span className='ap-card-label'>Utilizatori platformă</span>
                        {loadingAction ?
                            <FontAwesomeIcon className='spinner' icon={faSpinner}/> :
                            <div className='button-secondary' onClick={() => loadUsersAPI()}>Încarcă utilizatori</div>
                        }
                        <div className='button-secondary' onClick={() => simulateUserPrompt()}>Simulează utilizator</div>
                    </div>
                    {userAccounts.length > 0 &&
                        <div className='ap-table-wrap'>
                            <table className='ap-table'>
                                <thead>
                                    <tr>
                                        <th>Email</th>
                                        <th>uID</th>
                                        <th>Nume</th>
                                        <th>Ver. Email</th>
                                        <th>Ultima autentificare</th>
                                        <th>Creat la</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {userAccounts.map((usr, i) => (
                                        <tr key={usr.email + i}>
                                            <td>
                                                {usr.email}
                                                {usr.disabled && <span className='ap-tag-disabled'>dezactivat</span>}
                                            </td>
                                            <td className='ap-mono'>{usr.uid}</td>
                                            <td>{usr.displayName}</td>
                                            <td>
                                                <span className={`ap-status ap-status--${usr.emailVerified ? '1' : '2'}`}>
                                                    {usr.emailVerified.toString()}
                                                </span>
                                            </td>
                                            <td>{usr.metadata.lastSignInTime}</td>
                                            <td>{usr.metadata.creationTime}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    }
                </div>
            }

            {/* ── Popups ───────────────────────────────────────────────── */}
            {openPopup &&
                <Popup data={popupData} close={() => setOpenPopup(false)}>
                    {popupContent[popupData.content]}
                </Popup>
            }
            {printStart &&
                <section className='hidden'>
                    <InvoiceToPrint ref={invoiceRef} data={printData} toDownload={invoiceDownload}/>
                </section>
            }

        </div>
    )
}

export default AdminPanel